import React from 'react'

function TechSelectKlete() {
  return (
    <embed src="\pdfs\E2.2.3_kl-ete_07.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectKlete